import Vue from 'vue';
import { BfModal } from 'src/components/Butterfly';
export default Vue.extend({
    components: { BfModal },
    props: {
        visible: { type: Boolean, default: false },
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
});
